<template>
  <div class="min-h-screen flex flex-col justify-center items-center pt-6 sm:pt-0 mx-4">
    <div>
      <slot name="logo" />
    </div>

    <div
      :style="extraClassesName"
      class="w-full  my-6 sm2:p-10 p-6 bg-white shadow-md overflow-hidden rounded-lg sm2:rounded-3xl login-shadow"
    >
      <slot />
    </div>
  </div>
</template>
<script>
    export default {
        props: {
            extraClassesName: {
                type: String,
                default: 'max-width:500px',
                require:false
            },
        }
    }
</script>
<style scoped>
.login-shadow{
    box-shadow: 4px 4px 24px rgba(0, 0, 0, 0.04), -4px -4px 24px rgba(0, 0, 0, 0.04);
}
</style>
